/* istanbul ignore file */
import { DropDownFilter, ConditionProps } from 'framework/list';

import React from 'react';
import ReconciliationStatusDropdown from 'domain/finance/costAccounting/reconcilation/shared/input/ReconciliationStatusDropdown';

const ReconciliationStatusFilter = (props: Omit<ConditionProps, 'children'> & { label: string }) => {
  return (
    <DropDownFilter {...props}>
      <ReconciliationStatusDropdown {...props} />
    </DropDownFilter>
  );
};

export default ReconciliationStatusFilter;
